import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdminService } from 'src/app/services/admin/admin.service';
@Component({
  selector: 'app-file-viewer-modal',
  templateUrl: './file-viewer-modal.component.html',
  styleUrls: ['./file-viewer-modal.component.scss']
})
export class FileViewerModalComponent {
  @Input() modelId: any;
  @Input() title: any;
  @Input() modalName: string;
  @Input() pdfSrc: any;
  @Input() selectedInvoice: any;
  @Input() pdfLoading: boolean;
  @Output() callModals = new EventEmitter<{modalType: any, selectedInvoice: any, showSendInvoice: any}>();
  showSendInvoice: any
  constructor(
    private adminService: AdminService
  ) {
  }

  openSendModal(){
    this.showSendInvoice = 'send'
    this.callModals.emit({modalType: 'sendInvoice', selectedInvoice: this.selectedInvoice, showSendInvoice: this.showSendInvoice})

  }
}

